export const purchases = [
  { name: "María González", country: "Mexico" },
  { name: "Carlos Ramírez", country: "Colombia" },
  { name: "Lucía Fernández", country: "Argentina" },
  { name: "Javier Morales", country: "Peru" },
  { name: "Valentina Rojas", country: "Chile" },
  { name: "Diego Herrera", country: "Spain" },
  { name: "Camila Torres", country: "Ecuador" },
  { name: "Andrés Castillo", country: "Venezuela" },
  { name: "Sofía Mendoza", country: "Uruguay" },
  { name: "Mateo Vargas", country: "Bolivia" },
  { name: "Daniela Ruiz", country: "Costa Rica" },
  { name: "Gabriel Pérez", country: "Guatemala" },
  { name: "Isabella Navarro", country: "Paraguay" },
  { name: "Ricardo Flores", country: "Dominican Republic" },
  { name: "Natalia Ortiz", country: "Panama" },
  { name: "Fernando Silva", country: "Honduras" },
  { name: "Paula Jiménez", country: "El Salvador" },
  { name: "Alejandro Cruz", country: "Puerto Rico" },
  { name: "Mariana López", country: "Nicaragua" },
];
